import WidgetContext from 'embed_v2/components/Context'
import { useState, useContext } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import { ElementCheckboxOptions } from 'core/types/element/element_checkbox'
import optionsPropTypes from 'PropsSpec'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'backgroundColor'], {
  width: '100%',
  height: '100%'
})

const extractLabelStyles = getStylesFn(['color', 'fontSize', 'fontFamily', 'fontWeight'], {
  display: 'flex',
  alignItems: 'center'
})

const extractIconWrapperStyles = getStylesFn(
  [
    'border',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomRightRadius',
    'borderBottomLeftRadius',
    'backgroundColor'
  ],
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 7
  }
)

type Props = {
  options: ElementCheckboxOptions
}

const Checkbox = (props: Props) => {
  const { setViewerField, notification } = useContext(WidgetContext)
  const { options } = props
  const [value, setValue] = useState(false)
  const errors = (notification.errors as any)[options.key]

  const onChange = () => {
    setValue(prev => !prev)
    setViewerField(options.key, !value)
  }

  const styles = extractStyles(options)
  const labelStyles = extractLabelStyles(options)
  const iconWrapperStyles = {
    ...extractIconWrapperStyles(options.input),
    color: `rgba(${options.input.color})`,
    width: options.input.size,
    height: options.input.size,
    flex: `0 0 ${options.input.size}px`
  }

  return (
    <div style={styles} className="wf_reset wf_field wf_checkbox" onClick={onChange}>
      <div className="wf_reset wf_checkbox_wrapper">
        <label className="wf_reset" style={labelStyles}>
          <div className={`wf_reset wf_icon_wrapper ${errors ? 'wf_error' : ''}`} style={iconWrapperStyles}>
            {value && <CheckMark />}
          </div>
          {options.text}
        </label>
      </div>
    </div>
  )
}

Checkbox.propTypes = {
  options: optionsPropTypes('checkbox')
}

const CheckMark = () => (
  <svg className="wf_reset" width="12px" height="9px" viewBox="0 0 12 9">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-249.000000, -122.000000)" fill="currentColor" fillRule="nonzero">
        <g transform="translate(213.000000, 64.000000)">
          <g transform="translate(13.000000, 21.000000)">
            <g transform="translate(2.000000, 27.000000)">
              <g transform="translate(3.000000, 3.000000)">
                <g>
                  <g transform="translate(18.000000, 7.000000)">
                    <path d="M0.129487177,4.74786315 C0.0431623923,4.66153837 0,4.53205119 0,4.44572641 C0,4.35940162 0.0431623923,4.22991445 0.129487177,4.14358966 L0.733760669,3.53931617 C0.906410238,3.3666666 1.16538459,3.3666666 1.33803416,3.53931617 L1.38119655,3.58247856 L3.75512813,6.12905971 C3.84145292,6.21538449 3.97094009,6.21538449 4.05726488,6.12905971 L9.84102545,0.129487177 L9.88418784,0.129487177 L9.88418784,0.129487177 C10.0568374,-0.0431623923 10.3158118,-0.0431623923 10.4884613,0.129487177 L11.0927348,0.733760669 C11.2653844,0.906410238 11.2653844,1.16538459 11.0927348,1.33803416 L11.0927348,1.33803416 L4.18675205,8.50299128 C4.10042727,8.58931607 4.01410248,8.63247846 3.88461531,8.63247846 C3.75512813,8.63247846 3.66880335,8.58931607 3.58247856,8.50299128 L0.215811962,4.87735033 L0.129487177,4.74786315 Z"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default Checkbox
